import { createSlice } from '@reduxjs/toolkit';
import Reducers from './reducers';

export const initialState = {
  anchorEl: null,
  forceRender: false,
};

const batchMenu = createSlice({
  name: 'batchMenu',
  initialState,
  reducers: {
    setOpenBatchProcess: (state, action) => Reducers.openBatchProcessesReducer(state, action),
    setForceRender: (state, action) => Reducers.setForceRenderReducer(state, action),
  },
});

export const { setOpenBatchProcess, setForceRender } = batchMenu.actions;

export default batchMenu.reducer;
